__webpack_require__.p = "/Security-Log-Analyzer/";